import { defineMessages } from 'react-intl';

export default defineMessages({    
    removeRAClaimHeading:{
        id: 'policychange.views.ba-risk-analysis.Remove Claim?',
        defaultMessage: 'Remove Claim?' 
    },
    removeRAClaimBody:{
        id: 'policychange.views.ba-risk-analysis.Are you sure you want to remove this claim from the list?',
        defaultMessage: 'Are you sure you want to remove this claim from the list?' 
    },    
    claimCountTitle: {
        id: 'policychange.views.ba-risk-analysis.Claim:',
        defaultMessage: 'Claim : { count }'
    },
    selectOneCoverage:{
        id: 'policychange.views.ba-risk-analysis.Please select at least one coverage to proceed',
        defaultMessage: 'Please select at least one coverage to proceed'        
    },
});
